
<template>
  <div class="form-dialog">
    <div
      class="form-body-scroll"
    >
      <div
        class="form-text-title"
        style="position: relative;"
      >
        <div
          v-if="companyName === 'nuam'||companyName === 'a2censo'||companyName === 'bvc' || companyName === 'bsx' || companyName === 'bvl'"
          class="hide-icon-new"
          @click="onClose"
        />
        <div
          v-else
          class="hide-icon-new"
          @click="onClose"
        >
          <label
            for="angleDown"
            class="label-hover"
          >
            <v-icon
              name="angle-down"
              scale="1"
              class="icon-padding"
            />
          </label>
        </div>
      </div>
      <div
        v-if="companyName === 'nuam'||companyName === 'a2censo' ||companyName === 'bvc'|| companyName === 'bsx' || companyName === 'bvl'"
        class="form-text-title padding-title"
      >
        <div>
          <h1
            v-if="companyName === 'nuam'||companyName === 'a2censo' ||companyName === 'bvc'"
            class="form-text-title-h1"
          >
            Bienvenido
          </h1>
          <h1
            v-if="companyName === 'bsx'"
            class="form-text-title-h1"
          >
            BIENVENIDO
          </h1>
          <h1
            v-if="companyName === 'bvl'"
            class="form-text-title-h1"
          >
            <span class="welcome-subrayar">Bi</span>envenido
          </h1>
        </div>
        {{ title }}
      </div>
      <div
        v-else
        class="form-text-title padding-title"
      >
        <div
          v-if="welcomeFormLogo !== ''"
          class="form-title-img"
          :style="{ 'background': 'url(' + welcomeFormLogo + ')', 'background-size': '100%', 'background-repeat': 'no-repeat' }"
        />
        <div
          v-else
          class="form-title-img"
        />
        {{ title }}
      </div>
      <div class="form-components scroll">
        <div
          v-if="companyName === 'gb-trial-blue' || companyName === 'gb-trial-black'"
        >
          <div
            v-if="formName"
            class="form-section-input--new"
          >
            <div class="inputs-container-new">
              <label for="username">
                <v-icon
                  name="user"
                  scale="1"
                  style="padding: 15px 4px 0px 12px"
                />
              </label>
              <input
                id="username"
                ref="username"
                v-model="usuarioNombre"
                type="text"
                name="username"
                :placeholder="requeridoName ? 'Nombre *' : 'Nombre'"
                @keypress="keyPressCheckSpecialChars($event, 'name')"
                @keyup.enter="focusTo('mail')"
              >
              <span>{{ requeridoName ? 'Nombre *' : 'Nombre' }}</span>
            </div>
          </div>
          <div
            v-if="formMail"
            class="form-section-input--new"
          >
            <div class="inputs-container-new">
              <label for="mail">
                <v-icon
                  name="envelope"
                  scale="1"
                  style="padding: 15px 2px 0px 12px"
                />
              </label>
              <input
                id="mail"
                ref="mail"
                v-model="usuarioMail"
                type="text"
                :placeholder="requeridoMail ? 'Ej: Nombre@correo.cl *' : 'Ej: Nombre@correo.cl'"
                name="mail"
                @keypress="keyPressCheckSpecialChars($event, 'email')"
                @keyup.enter="focusTo('telefono')"
              >
              <span>{{ requeridoMail ? 'Email *' : 'Email' }}</span>
            </div>
          </div>
          <div
            v-if="formFone"
            class="form-section-input--new"
          >
            <div class="inputs-container-new">
              <label for="telefono">
                <v-icon
                  name="mobile-alt"
                  scale="1"
                  style="padding: 15px 6px 0px 14px"
                />
              </label>
              <input
                id="telefono"
                ref="telefono"
                v-model="usuarioTelefono"
                type="text"
                name="telefono"
                :placeholder="requeridoFone ? 'Ej: 56 9 1234 5678 *' : 'Ej: 56 9 1234 5678'"
                maxlength="14"
                @keypress="keyPressCheckSpecialChars($event, 'phone')"
                @change="cleanSpecialChars('telefono', 'phone')"
                @keyup.enter="_sentClick"
              >
              <span>{{ requeridoFone ? 'Celular *' : 'Celular' }}</span>
            </div>
          </div>
        </div>
        <div
          v-else-if="companyName === 'simpli'"
        >
          <div class="form-section-input--new">
            <input
              id="username"
              ref="username"
              v-model="usuarioNombre"
              type="text"
              name="username"
              placeholder=" "
              @keypress="keyPressCheckSpecialChars($event, 'name')"
              @keyup.enter="focusTo('mail')"
            >
            <span>Nombre</span>
          </div>
          <div class="form-section-input--new">
            <input
              id="mail"
              ref="mail"
              v-model="usuarioMail"
              type="text"
              placeholder=" "
              name="mail"
              @keypress="keyPressCheckSpecialChars($event, 'email')"
              @keyup.enter="focusTo('telefono')"
            >
            <span>Email</span>
          </div>
          <div class="form-section-input--new">
            <input
              id="telefono"
              ref="telefono"
              v-model="usuarioTelefono"
              type="text"
              name="telefono"
              placeholder=" "
              maxlength="14"
              @keypress="keyPressCheckSpecialChars($event, 'phone')"
              @change="cleanSpecialChars('telefono', 'phone')"
              @keyup.enter="_sentClick"
            >
            <span>Celular</span>
          </div>
        </div>
        <div
          v-else-if="companyName === 'nuam' || companyName === 'a2censo'||companyName === 'bvc'|| companyName === 'bsx' || companyName === 'bvl'"
        >
          <a
            v-if="companyName === 'bvc'"
            class="text-label"
          >Nombre</a>
          <div
            v-if="formName"
            class="form__field"
            :class="{ 'form__field--filled': usuarioNombre }"
          >
            <label for="username">
              <IconsForm
                :is-filled="!usuarioNombre?false:true"
                :company="companyName"
                :icon-name="'person'"
              />
            </label>
            <input
              id="username"
              ref="username"
              v-model="usuarioNombre"
              autocomplete="off"
              type="text"
              name="username"
              value
              :placeholder="requeridoName ? 'Nombre *' : 'Nombre'"
              required
              maxlength="60"
              @keypress="keyPressCheckSpecialChars($event, 'name')"
              @keyup.enter="focusTo('mail')"
            >
          </div>
          <a
            v-if="companyName === 'bvc'"
            class="text-label"
          >Correo</a>
          <div
            v-if="formMail"
            class="form__field"
            :class="{ 'form__field--filled': usuarioMail }"
          >
            <label for="mail">
              <IconsForm
                :is-filled="!usuarioMail?false:true"
                :company="companyName"
                :icon-name="'email'"
              />
            </label>
            <input
              id="mail"
              ref="mail"
              v-model="usuarioMail"
              autocomplete="off"
              type="text"
              name="mail"
              maxlength="45"
              value
              :placeholder="requeridoMail ? 'Correo electrónico *' : 'Correo electrónico'"
              required
              @keypress="keyPressCheckSpecialChars($event, 'email')"
              @keyup.enter="focusTo('telefono')"
            >
          </div>
          <a
            v-if="companyName === 'bvc'"
            class="text-label"
          >Teléfono</a>
          <div
            v-if="formFone"
            class="form__field"
            :class="{ 'form__field--filled': usuarioTelefono }"
          >
            <label for="telefono">
              <IconsForm
                :is-filled="!usuarioTelefono?false:true"
                :company="companyName"
                :icon-name="'phone'"
              />
            </label>
            <input
              id="telefono"
              ref="telefono"
              v-model="usuarioTelefono"
              autocomplete="off"
              type="text"
              name="telefono"
              value=""
              :placeholder="requeridoFone ? 'xx 1234 5678 *' : 'xx 1234 5678'"
              maxlength="14"
              required
              @focus="_clearError"
              @keypress="keyPressCheckSpecialChars($event, 'phone')"
              @change="cleanSpecialChars('telefono', 'phone')"
              @keyup.enter="_sentClick"
            >
            <!--<div class="container__input_phone">
              <input
                value="569"
                disabled="true"
                type="text"
                class="form__input_phone"
              >
              <input
                id="telefono"
                ref="telefono"
                v-model="usuarioTelefono"
                autocomplete="off"
                type="text"
                name="telefono"
                value=""
                placeholder="12345678"
                maxlength="8"
                required
                @focus="_clearError"
                @keypress="keyPressCheckSpecialChars($event, 'phone')"
                @change="cleanSpecialChars('telefono', 'phone')"
                @keyup.enter="_sentClick"
              >
            </div>-->
          </div>
          <div
            v-if="hayPoliticas"
            class="form__field_check"
          >
            <div class="checkbox-wrapper">
              <input
                id="polity-checkbox"
                ref="polityCheckbox"
                v-model="polityCheck"
                type="checkbox"
                name="politycheck"
                :checked="polityCheck"
                class="form__checkbox"
                required
              >
              <span
                v-show="polityCheck === true"
                class="checkmark-gb"
              >
                <IconsForm
                  :company="companyName"
                  :icon-name="'checkmark'"
                />
              </span>
            </div>
            <label class="form__label-text">
              Acepta nuestro <span v-html="enlacesCombinados" />
            </label>
          </div>
        </div>
        <div
          v-else
        >
          <div
            v-if="formName"
            class="form__field"
          >
            <label for="username">
              <v-icon
                name="user"
                scale="1"
                style="margin: 0 1px 5px 1px"
              />
            </label>
            <input
              id="username"
              ref="username"
              v-model="usuarioNombre"
              autocomplete="off"
              type="text"
              name="username"
              value
              :placeholder="requeridoName ? 'Nombre *' : 'Nombre'"
              required
              maxlength="60"
              @keypress="keyPressCheckSpecialChars($event, 'name')"
              @keyup.enter="focusTo('mail')"
            >
          </div>
          <div
            v-if="formMail"
            class="form__field"
          >
            <label for="mail">
              <v-icon
                name="comment-dots"
                scale="1"
                style="margin-bottom: 5px"
              />
            </label>
            <input
              id="mail"
              ref="mail"
              v-model="usuarioMail"
              autocomplete="off"
              type="text"
              name="mail"
              maxlength="45"
              value
              :placeholder="requeridoMail ? 'Email *' : 'Email'"
              required
              @keypress="keyPressCheckSpecialChars($event, 'email')"
              @keyup.enter="focusTo('telefono')"
            >
          </div>
          <div
            v-if="formFone"
            class="form__field"
          >
            <label for="telefono">
              <v-icon
                name="mobile-alt"
                scale="1"
                class="form__field_phone_icon"
                style="margin: 0 2px 3px 4px; flex: 0;"
              />
            </label>
            <input
              id="telefono"
              ref="telefono"
              v-model="usuarioTelefono"
              autocomplete="off"
              type="text"
              name="telefono"
              value=""
              :placeholder="requeridoFone ? '569 1234 5678 *' : '569 1234 5678'"
              maxlength="14"
              required
              @focus="_clearError"
              @keypress="keyPressCheckSpecialChars($event, 'phone')"
              @change="cleanSpecialChars('telefono', 'phone')"
              @keyup.enter="_sentClick"
            >
            <!--<div class="container__input_phone">
              <input
                value="569"
                disabled="true"
                type="text"
                class="form__input_phone"
              >
              <input
                id="telefono"
                ref="telefono"
                v-model="usuarioTelefono"
                autocomplete="off"
                type="text"
                name="telefono"
                value=""
                placeholder="12345678"
                maxlength="8"
                required
                @focus="_clearError"
                @keypress="keyPressCheckSpecialChars($event, 'phone')"
                @change="cleanSpecialChars('telefono', 'phone')"
                @keyup.enter="_sentClick"
              >
            </div>-->
          </div>
        </div>
        <div class="form-box-button scroll margin_btn">
          <template v-if="!omitir && !requeridoName && !requeridoFone && !requeridoMail">
            <button
              class="button-secondary"
              @click="_cancelClick"
              v-text="(companyName === 'nuam' || companyName === 'a2censo'||companyName === 'bvc'|| companyName === 'bsx' || companyName === 'bvl')?'Omitir por ahora':'Omitir'"
            />
          </template>
          <button
            class="button-primary"
            @click="_sentClick"
            v-text="companyName === 'bsx' ?'ACEPTAR':'Aceptar'"
          />
        </div>
      </div>
      <!-- MSG -->
      <div class="form-error">
        &nbsp;{{ errormsg }}
      </div>
    </div>
  </div>
</template>
<script>
import { serverUI } from './main'
import Icon from 'vue-awesome/components/Icon'
import 'vue-awesome/icons/user'
import 'vue-awesome/icons/arrow-down'
import 'vue-awesome/icons/angle-down'
import 'vue-awesome/icons/lock'
import formUtils from './formUtils'
import utils from './utils'
import IconsForm from './IconsForm.vue'

export default {
  components: {
    'v-icon': Icon,
    IconsForm
  },

  props: {
    cssStyle: {
      type: Object
    },
    companyName: {
      type: String,
      default: () => ''
    },
    welcomeFormLogo: {
      type: String,
      default: () => ''
    },
    onClose: {
      type: Function,
      required: true
    }
  },
  methods: {
    ...formUtils.formBase,
    _sentClick () {
      this.errormsg = ''
      const phoneRegex = new RegExp(/^[1-9]{1}[0-9]{8}$/g)
      if (this.usuarioNombre === '' && this.requeridoName) {
        this.$refs.username.focus()
        this.errormsg = 'Debes ingresar un nombre'
        return
      }
      if (this.usuarioMail === '' && this.requeridoMail) {
        this.$refs.mail.focus()
        this.errormsg = 'Debes ingresar un email'
        return
      }
      if ((this.usuarioMail !== '' && this.requeridoMail) || (this.usuarioMail !== '' && !this.requeridoMail)) {
        if (!utils.isEmail(this.usuarioMail)) {
          this.$refs.mail.focus()
          this.errormsg = 'Debes ingresar un email válido'
          return
        }
      }
      const validatePhone = this.validatePhoneFormat(this.usuarioTelefono)
      if ((this.usuarioTelefono === '' && this.requeridoFone) || (this.usuarioTelefono !== '' && this.requeridoFone) || (this.usuarioTelefono !== '' && !this.requeridoFone)) {
        if (this.usuarioTelefono === '') {
          this.$refs.telefono.focus()
          this.errormsg = 'Debes ingresar un número de teléfono'
          return
        }
        if (!this.usuarioTelefono || this.usuarioTelefono.length < 9 || this.usuarioTelefono.length > 14 || !validatePhone) {
          this.$refs.telefono.focus()
          this.errormsg = 'Debes ingresar un número de teléfono válido'
          return
        }
      }
      const checkboxElement = this.$refs.polityCheckbox

      if (checkboxElement && !this.polityCheck) {
        this.errormsg = 'Debes aceptar nuestro consentimiento de recolección de datos y términos y condiciones'
        return
      }

      /* Por ahora solo valida nombre */
      /*
      if (!utils.validaRut(this.usuarioRut)) {
        this.$refs.username.focus();
        this.errormsg = 'Debe ingregar RUT válido';
        return;
      }
      if (this.usuarioPassword == '') {
        this.$refs.password.focus();
        this.errormsg = 'Debe ingresar clave de internet';
        return;
      }
      if (this.usuarioPassword.length>8) {
        this.$refs.password.focus();
        this.errormsg = 'Clave excede largo permitido';
        return;
      }
      if (this.usuarioPassword.length<4) {
        this.$refs.password.focus();
        this.errormsg = 'Clave largo no permitido';
        return;
      }
      */
      const dataToSend = {
        form: 'Login',
        evento: 'sentClick',
        data: {
          usuario_nombre: this.usuarioNombre,
          usuario_mail: this.usuarioMail,
          usuario_telefono: `${this.usuarioTelefono}`
        }
      }
      serverUI.$emit('FormEvent', dataToSend)
    },
    _cancelClick () {
      serverUI.$emit('FormEvent', {
        form: 'Login',
        evento: 'cancelClick',
        dato: 'CANCELANDO'
      })
    }
  },
  data () {
    return {
      usuarioNombre: '',
      usuarioMail: '',
      usuarioRut: '',
      usuarioTelefono: '',
      usuarioPassword: '',
      polityCheck: false,
      errormsg: '',
      omitir: false,
      title: 'Para mejorar la calidad de esta conversación, por favor ingresa tus datos:',
      titleTerminosCondiciones: 'términos y condiciones',
      titleTratamientoDatos: 'política de tratamiento de datos',
      titleRecoleccionDatos: 'consentimiento de recolección de datos',
      linkTyc: '',
      linkCUd: '',
      linkTD: '',
      enabledTyC: false,
      enabledTD: false,
      enabledCUd: false,
      inputStyleV2: true,
      formName: true,
      formMail: true,
      formFone: true,
      requeridoName: false,
      requeridoMail: false,
      requeridoFone: false,
      showTooltip: false // Propiedad para controlar la visibilidad del tooltip
      // Otras propiedades
    }
  },
  computed: {
    hayPoliticas () {
      return this.enabledCUd || this.enabledTD || this.enabledTyC
    },
    enlacesCombinados () {
      const enlaces = []

      if (this.enabledCUd) {
        enlaces.push(`<a href="${this.linkCUd}" target="_blank"><b>${this.titleRecoleccionDatos}</b></a>`)
      }

      if (this.enabledTD) {
        enlaces.push(`<a href="${this.linkTD}" target="_blank"><b>${this.titleTratamientoDatos}</b></a>`)
      }

      if (this.enabledTyC) {
        enlaces.push(`<a href="${this.linkTyc}" target="_blank"><b>${this.titleTerminosCondiciones}</b></a>`)
      }

      if (enlaces.length === 1) {
        return enlaces[0]
      } else if (enlaces.length === 2) {
        return `${enlaces[0]} y ${enlaces[1]}`
      } else if (enlaces.length === 3) {
        return `${enlaces[0]}, ${enlaces[1]} y ${enlaces[2]}`
      } else {
        return ''
      }
    }
  },
  created () {
    // Señales recibidas
    serverUI.$on('FormEvent', (e) => {
      if (e.form !== 'Login') return
      if (e.evento === 'init') {
        this.formName = e.dato.formName
        this.formMail = e.dato.formMail
        this.formFone = e.dato.formFone
        this.requeridoName = e.dato.requeridoName
        this.requeridoMail = e.dato.requeridoMail
        this.requeridoFone = e.dato.requeridoFone
        this.omitir = e.dato.requerido
        this.enabledTyC = e.dato?.channelData?.plugin?.terms_conditions?.enabled
        this.enabledCUd = e.dato?.channelData?.plugin?.data_collection?.enabled
        this.enabledTD = e.dato?.channelData?.plugin?.data_treatment?.enabled
        this.titleTerminosCondiciones = e.dato?.channelData?.plugin?.terms_conditions?.title
        this.titleTratamientoDatos = e.dato?.channelData?.plugin?.data_treatment?.title
        this.titleRecoleccionDatos = e.dato?.channelData?.plugin?.data_collection?.title
        this.linkTyc = e.dato?.channelData?.plugin?.terms_conditions?.link
        this.linkCUd = e.dato?.channelData?.plugin?.data_collection?.link
        this.linkTD = e.dato?.channelData?.plugin?.data_treatment?.link
        this.title =
          e.dato.formMessage && e.dato.formMessage !== ''
            ? e.dato.formMessage
            : 'Para mejorar la calidad de esta conversación, por favor ingresa tus datos:'
      }
      if (e.evento === 'newdata') {
        this.omitir = e.dato.requerido
        this.title =
          e.dato.formMessage && e.dato.formMessage !== ''
            ? e.dato.formMessage
            : 'Para mejorar la calidad de esta conversación, por favor ingresa tus datos:'
      }
    })
  }
}
</script>
<style lang="scss">
@import './assets/styles/chatbot/form.scss';
</style>
